import { authApi, couponApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_CDIC_PROGRAM, PATH_CREATE_COUPON_FAMILY } from "@configs";
import { ICoupon, ICouponProgram } from "@interfaces";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { CdicProgramForm } from "src/Modules/coupon/Program";

export const PageCreateCdicProgram = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const [coupon, setCoupon] = useState<ICouponProgram>();

  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_CDIC_PROGRAM}>{t("page.create_program")}</a>,
    },
  ];

  useEffect(() => {
    if (id) {
      fetchCouponProgram();
    }
  }, [id]);

  const fetchCouponProgram = async () => {
    try {
      dispatch(setLoading(true));
      const res = await couponApi.getProgram(id);
      setCoupon(res.data);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicProgramForm coupon={coupon} />
      </StyledCreate>
    </>
  );
};
